export default __webpack_public_path__ + "static/media/waiting-room-2.69834fc9.jpg";